<template>
    <b-input-group>

        <b-form-input :value="url" :disabled="true"></b-form-input>

        <b-input-group-append>

            <b-button
                v-clipboard:copy="url"
                v-clipboard:success="onSuccess"
                v-clipboard:error="onError"
                variant="primary">
                {{ __('invite.Copy Link') }}
            </b-button>

        </b-input-group-append>

    </b-input-group>
</template>

<script>

export default {
    props: ['url'],
    methods: {

        onSuccess(event) {
            this.$toast.success(this.__('invite.Copied') + ' : ' + event.text)
        },

        onError(event) {
            this.$toast.error(this.__('invite.Error') + ' : ' + event.text)
        }

    }
}
</script>

<style scoped>

</style>
